import moment from 'src/app/utils/moment';

export interface UserHabitInstance {
  id: string;
  achieved: boolean;
  date: string;
  notes?: string;
}

export class UserHabit {
  id: string = null;
  title: string = null;
  color: string = null;
  startDate: string = null;
  endDate: string = null;
  status: "scheduled" | "active" | "complete";
  organization: string;
  description?: string;
  recurring?: {
    interval: number;
    frequency: "daily" | "weekly" | "monthly";
    until?: string;
  };
  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  
  constructor(init: Partial<UserHabit>) {
    Object.assign(this, init);
  }
}